import logsMessageFr from './logs/fr-FR';

export default {
  logs: logsMessageFr,
  icon: 'local_shipping',
  dispatcher_icon: 'mdi-account',
  technician_icon: 'mdi-tools',
  callcenter_icon: 'mdi-headphones',
  dangerous_situation_icon: 'mdi-alert',
  name: "Demandes d'intervention",
  noItems: "Il n'y a pas encore d'échanges",
  description: 'Description',
  create: {
    icon: 'mdi-plus',
    title: 'Créer une DI',
  },
  treated: {
    create: {
      icon: 'mdi-plus',
      title: 'Créer une DI',
    },
    name: "Demandes d'intervention",
  },
  HISUntreated: {
    create: {
      icon: 'mdi-plus',
      title: 'Créer une DI',
    },
    name: "Demandes d'intervention",
  },
  HISTreated: {
    create: {
      icon: 'mdi-plus',
      title: 'Créer une DI',
    },
    name: "Demandes d'intervention",
  },
  item: {
    noItems: 'DI introuvable',
    link: 'Lien vers la DI',
  },
  fields: {
    actions: 'Actions',
    action: 'Action',
    adress: 'Adresse',
    appelant: 'Appelant',
    customer_comment: 'Commentaire appelant',
    customer_files: 'PJ',
    customer_name: 'Appelant',
    customer_phone: 'Tel',
    customer_type: 'Type',
    dispatched: 'Prise',
    dispatcher_userid: 'Dispatcheur',
    dispatcher_last_name: 'Mise en pause par',
    epex: 'EPEX',
    expiration: 'Expiration',
    expiration_datetime: 'Expirée depuis',
    expiration_delay: "Délai d'expiration",
    his_treatment: 'À traiter',
    id: "N° d'itv",
    intervention: 'Intervention',
    limit_datetime: 'Date limite',
    location: 'Localisation',
    m2m_remotemanagement_enabled: 'PV',
    pause_comment: 'Commentaire de mise en pause',
    pause_duration: 'Durée de mise en pause',
    postal_code: 'Commune',
    pro_consig: 'Consignes agrégées',
    limit_datetime: 'Date prévisionnelle',
    properties: {
      code: 'Installation',
      name: 'Libellé long',
    },
    property: {
      code: 'Installation',
      postal_code: 'Code postal',
      short_name: 'Nom court installation',
    },
    property_code: 'Installation',
    property_name: 'Nom installation',
    property_shortname: 'Nom court installation',
    purpose: 'Usage',
    rejected: 'Rejetée',
    requester: 'Appelant',
    request_id: "N° d'itv",
    signalisation_datetime: "Date d'appel",
    status: 'Etat',
    technicians: {
      name: 'Technicien affecté',
    },
    transformable: 'DIT',
    transformable_request: 'Ordonnancée',
    transmitted: 'Transmise à Genesis Mobile',
    type: 'Symptômes[Qualifs]',
    work_order_group_qualif_name: 'Qualification',
    work_order_group_type_name: 'Symptôme',
    request_customer_type: 'Typologie client',
  },
  tab: {
    icon_treated: 'mdi-truck-check',
    icon_untreated: 'mdi-truck-fast',
    msg_treated: 'Traitée',
    msg_untreated: 'À traiter',
  },
  titles: {
    toTreat: 'À traiter',
    treated: 'Traitées',
  },
  details: {
    titles: {
      alerts: 'Alertes Hypervision en cours',
      best_deadlines: 'Meilleurs délais',
      contract: {
        md: 'Contrat : MD',
        part1: 'Contrat : ',
        part2: 'h',
      },
      contractualData: 'Données contractuelles',
      dispatcher: 'Dispatcheur',
      documents: 'Documents',
      exploitation: 'Exploitation',
      fri: 'FRI',
      interventions: 'Interventions',
      general: 'Généralités',
      HNO: 'HNO',
      HO: 'HO',
      infoDI: 'Informations sur la DI',
      logbook: 'Journal de bord',
      maintenance: 'Maintenance',
      mother_request: 'DI mère : ',
      no_actionplan: "Pas de plan d'actions",
      orders: 'Consignes',
      property: 'Installation',
      propertyState: 'Etat installation',
      recurrence: 'Récurrences',
      requests: "Demandes d'intervention",
      sondes: 'Sondes',
      specificSymptoms: 'Symptômes spécifiques',
      dangerousSituations: 'Situations Dangereuses',
      noDangerousSituations: 'Pas de situation dangereuse déclarée en cours',
      dangerousSituationsList: 'SD avec consigne en cours',
    },
    property: {
      code: 'Numero',
      name: 'Nom',
      request_ordo: 'Ordo corr',
      short_name: 'Nom court',
      entity_region: 'Region',
      cofelyvision: 'MyVision',
    },
    reactive_instructions: 'Technicien',
    dispatcher_instructions: 'Dispatcheur',
    operator_instructions: 'Opérateur',
    technician_name: 'Tech en charge',
    technician_phone: 'Téléphone Tech en charge',
  },
  actions: {
    add_instruction: 'Ajouter une consigne',
    autofilled_comment_ignition:
      "Nécessité d'intervention sur place suite à demande de mise en service du chauffage récente",
    autofilled_comment_shutdown:
      "Nécessité d'intervention sur place suite à demande de mise à l’arrêt du chauffage récente",
    autofilled_comment:
      "Nécessité d'intervention sur place suite à demande de mise en service / à l’arrêt du chauffage récente",
    workorder_report: "Compte-rendu d'intervention",
    workorder_report_short: 'CRI',
    add_request: "Nouvelle Demande d'Intervention",
    tech_intervened: 'Technicien intervenu',
    diagnosis: 'Diagnostic',
    treatment: 'Traitement',
    prestation: 'Prestation',
    begin_datetime: 'Date heure début',
    end_datetime: 'Date heure fin',
    duration: 'Durée',
    team_number: "Numéro d'équipement",
    reason: 'Motif',
    remote: 'A distance',
    ended: 'Terminée',
    yes: 'Oui',
    shifting: 'Dont déplacement',
    no: 'Non',
    yes_continued: 'Oui, à suivre',
    comment: 'Commentaire',
    rejection: 'Rejet',
    rejection_reason: 'Motif de rejet',
    no_rejection_reason: 'Le motif de rejet est obligatoire',
    engiedirect_visible: "Visible sur l'extranet Engiedirect",
    pause: 'Mise en pause',
    pause_reason: 'Motif de mise en pause',
    no_pause_reason: 'Le motif de mise en pause est obligatoire',
    validate: 'Valider',
    cancel: 'Annuler',
    delete_param: 'Supprimer paramétrage',
    transmission: 'Transmission',
    transmit: 'Transmettre',
    status: 'Etat',
  },
};
